import { render, staticRenderFns } from "./SmBtnTextLinkAbbreviation.vue?vue&type=template&id=1c40cc24&scoped=true&"
import script from "./SmBtnTextLinkAbbreviation.vue?vue&type=script&lang=ts&"
export * from "./SmBtnTextLinkAbbreviation.vue?vue&type=script&lang=ts&"
import style0 from "./SmBtnTextLinkAbbreviation.vue?vue&type=style&index=0&id=1c40cc24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c40cc24",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
